import React from 'react';
import { connect } from 'react-redux';
import filesize from 'filesize';
import Icon from 'components/icon';
import ExternalLink from 'components/link/external';
import ConsoleLink from 'components/console/link';
import Collection from './Collection';

const query = {
  //
};

const tabs = {
  default: {
    label: 'All files',
  },
  images: {
    label: 'Images',
    query: {
      content_type: { $regex: '^image' },
    },
  },
  documents: {
    label: 'Documents',
    query: {
      content_type: { $regex: '^(?!image)' },
    },
  },
};

const filters = {
  date_created: {
    label: 'Date uploaded',
    operators: ['after', 'before'],
    type: 'date',
  },
  length: {
    label: 'File size (kB)',
    operators: ['gt', 'lt', 'eq'],
    type: 'number',
    func: ({ gt, lt, eq }) => {
      return {
        length: {
          ...(gt > 0 ? { $gt: gt * 1024 } : undefined),
          ...(lt > 0 ? { $lt: lt * 1024 } : undefined),
          ...(eq > 0 ? { $eq: eq * 1024 } : undefined),
        },
      };
    },
  },
  content_type: {
    label: 'Content type',
    options: [
      { value: 'images', label: 'Images' },
      { value: 'documents', label: 'Documents' },
    ],
    func: (query) => {
      if (query === 'images') {
        return { content_type: { $regex: '^image' } };
      } else {
        return { content_type: { $regex: '^(?!image)' } };
      }
    },
  },
};

const fields = {
  name: {
    label: 'File',
    sort: ['filename'],
    default: true,
    func: ({ id, filename, url }) => {
      return <ExternalLink to={url}>{filename || id}</ExternalLink>;
    },
  },
  length: {
    label: 'Size',
    func: ({ length }) => filesize(length || 0),
  },
  content_type: {
    label: 'Type',
    func: ({ content_type, width, height }) => (
      <>
        {content_type}
        {width > 0 && height > 0 && (
          <span className="muted">
            &nbsp;&middot;&nbsp;{width} &times; {height}
          </span>
        )}
      </>
    ),
  },
  date_uploaded: {
    label: 'Created',
    type: 'date',
  },
  console: {
    label: '',
    align: 'right',
    func: ({ id }) => (
      <ConsoleLink model=":files" uri={id} icon={false} buttonType={null}>
        <Icon fa="ellipsis-h" />
      </ConsoleLink>
    ),
  },
};

const bulkActions = [
  {
    modal: 'BulkDelete',
    label: 'Delete',
    type: 'danger inverse',
  },
];

const mapStateToProps = (state) => ({
  //
});

const mapDispatchToProps = (dispatch) => ({
  //
});

export class Files extends React.Component {
  render() {
    return (
      <Collection
        {...this.props}
        title="Files"
        model=":files"
        tabs={tabs}
        filters={filters}
        fields={fields}
        query={query}
        bulkActions={undefined /*bulkActions*/}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Files);
